<!-- src/components/index.vue -->

<template>
  <nav class="navbar navbar-expand-lg backgroundblacktodarkgray sticky-top p-0">
    <div class="container-fluid">
      <router-link
        to="/"
        class="navbar-brand fw-bold MainTitleFont textwhite textmainhover d-flex align-items-center"
        :class="{ 'textmaintoggle': $route.path === '/' }"
      >
        <span class="brand-icon-wrap" :class="{ 'ml-3': windowWidth < 767.98 }">
          <img
            class="brand-icon-white maxwidthfixed50px p-1 mr-2"
            
            src="https://r4.sinlessproject.com/media/Assets/SinlessStudios-icon-white.png"
            alt="Sinless Project Logo"
          >
          <img
            class="brand-icon-green maxwidthfixed50px p-1 mr-2"
            src="https://r4.sinlessproject.com/media/Assets/SinlessStudios-icon-green.png"
            alt="Sinless Project Logo"
          >
        </span>
        Sinless Project
      </router-link>

      <i
        class="bi bi-list navbar-toggler textwhite"
        :class="{ 'textmaintoggle': isMenuOpen }"
        role="button"
        tabindex="0"
        aria-controls="navbarNav"
        :aria-expanded="isMenuOpen"
        aria-label="Toggle navigation"
        @click="isMenuOpen = !isMenuOpen"
        @keydown.enter="isMenuOpen = !isMenuOpen"
        @keydown.space.prevent="isMenuOpen = !isMenuOpen"
      ></i>

      <div class="collapse navbar-collapse" :class="{ show: isMenuOpen }" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li v-for="link in navLinks" :key="link.path" class="nav-item" :class="{ 'pl-4': isMenuOpen }">
            <router-link
              :to="link.path"
              class="nav-link subTitleFont navbarGlobalList"
              :class="{ 'textmaintoggle': $route.path === link.path }"
              @click="isMenuOpen = false"
            >
              {{ link.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>


<style scoped>

/* ── Icon: white shown by default, green hidden ──────────── */
.brand-icon-wrap {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.brand-icon-green {
  display: none;
}

/* ── Hover: swap to green icon, no glow ──────────────────── */
.navbar-brand:hover .brand-icon-white {
  display: none;
}
.navbar-brand:hover .brand-icon-green {
  display: block;
  filter: none;
}

/* ── Active: swap to green icon + glow ───────────────────── */
.navbar-brand.textmaintoggle .brand-icon-white {
  display: none;
}
.navbar-brand.textmaintoggle .brand-icon-green {
  display: block;
  filter:
    drop-shadow(0 0 4px var(--main-text-color))
    drop-shadow(0 0 12px var(--main-text-color));
}

/* ── Active + hover: glow must survive (higher specificity) ─ */
.navbar-brand.textmaintoggle:hover .brand-icon-green {
  filter:
    drop-shadow(0 0 4px var(--main-text-color))
    drop-shadow(0 0 12px var(--main-text-color));
}

/* ── Mobile menu toggler: glow to match active nav-link state ─ */
.navbar-toggler {
  border-color: transparent;
}
.navbar-toggler:focus {
  box-shadow: none;
}
.navbar-toggler.bi-list {
  color: var(--purewhite);
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}
.navbar-toggler.textmaintoggle {
  color: var(--main-text-color);
  text-shadow: 0px 0px 20px var(--main-text-color);
}

/* Small screens */
@media (max-width: 575.98px) {

}

/* Medium screens */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Large screens */
@media (min-width: 768px) {

}
</style>
<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'animate.css';

export default {
  name: 'HomePagePart1ArtistsNews',
  props: ['id'],
  data() {
    return {
      // Define the links here so the v-for can see them
      navLinks: [
        { name: 'Home', path: '/' },
        { name: 'Gallery', path: '/gallery' },
        { name: 'About', path: '/about' },
        { name: 'Contact', path: '/contact' }
      ],
      user: null,
      userSettings: null,
      isMenuOpen: false,
      windowWidth: window.innerWidth,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchUserData(newId);
        }
      }
    }
  },
  mounted() {
    AOS.init();
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
  }
}
</script>
